import { users } from './users';
import { requests } from './requests';
import { charges } from './charges';

export const referral = {
  namespaced: true,
  modules: {
    users,
    requests,
    charges
  }
};
